import React from 'react';

function Button({
  id,
  complete,
  handleClick,
  btnText,
  icon = '',
  disabled = false,
  classes = [],
  unreadMessages = 0
}) {
  return (
    <div className={`grid__col-xs-12 u--margin-bottom-20 ${classes.join(' ')}`}>
      <button
        id={id}
        className={`btn btn--gold btn--outline btn--has-arrow module-hover-root ${
          complete ? 'btn--pip-complete' : ''
        } ${icon}`}
        onClick={handleClick}
        disabled={disabled ? disabled : ''}
      >
        <span className="btn__content">
          <span className="btn__text">
            {btnText}
            {unreadMessages > 0 && (
              <span className="btn__text--message-count">
                {unreadMessages}
              </span>
            )}
          </span>
          <span
            className={`btn__arrow ${!icon && 'arrow arrow--black'}`}
          ></span>
        </span>
      </button>
    </div>
  );
}

export default Button;
